/**
 * 品牌页 2.0 — GSAP ScrollTrigger + Lenis 初始化
 * 仅在 page.about-euhomy2 模板加载（见 snippets/about-euhomy2-assets.liquid）
 */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var callbacks = [];
  var destroyers = [];
  var lenisInstance = null;
  var initialized = false;

  function whenLibsReady(callback) {
    if (window.gsap && window.ScrollTrigger && window.Lenis) {
      callback();
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (window.gsap && window.ScrollTrigger && window.Lenis) {
        window.clearInterval(timer);
        callback();
        return;
      }
      if (attempts > 100) {
        window.clearInterval(timer);
        console.warn('[AboutEuhomy2] GSAP / ScrollTrigger / Lenis failed to load.');
      }
    }, 50);
  }

  function getHeaderOffset() {
    var header = document.querySelector('header, .shopify-section-group-header-group, #shopify-section-header');
    if (!header) return 0;
    return header.getBoundingClientRect().height || 0;
  }

  function shouldUseLenis() {
    if (window.matchMedia('(max-width: 768px)').matches) return false;
    var root = document.querySelector('[data-about-euhomy2-root]');
    if (!root) return true;
    return root.getAttribute('data-enable-smooth-scroll') !== 'false';
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function getPinScrollOptions(isMobile) {
    if (isMobile) {
      return {
        scrub: 0.45,
        anticipatePin: 1,
        fastScrollEnd: true,
      };
    }
    return {
      scrub: true,
      anticipatePin: 0,
      fastScrollEnd: false,
    };
  }

  /** 读取全站流体 --rem（PC：clientWidth/1920 连续热更新；移动端固定为 1） */
  function getRem() {
    var rem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rem'));
    return Number.isFinite(rem) && rem > 0 ? rem : 1;
  }

  function remPx(n) {
    return (Number(n) || 0) * getRem();
  }

  function initLenis() {
    if (REDUCED_MOTION || lenisInstance || !shouldUseLenis()) return null;

    lenisInstance = new Lenis({
      lerp: 0.08,
      smoothWheel: true,
      touchMultiplier: 1,
    });

    document.documentElement.classList.add('lenis', 'lenis-smooth');

    lenisInstance.on('scroll', function () {
      if (window.ScrollTrigger) {
        ScrollTrigger.update();
      }
    });

    gsap.ticker.add(function (time) {
      lenisInstance.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(1000, 16);

    return lenisInstance;
  }

  function createApi() {
    return {
      gsap: window.gsap,
      ScrollTrigger: window.ScrollTrigger,
      lenis: lenisInstance,
      reducedMotion: REDUCED_MOTION,
      headerOffset: getHeaderOffset(),
      root: document.querySelector('[data-about-euhomy2-root]') || document.body,
    };
  }

  function runCallbacks() {
    destroyers.forEach(function (destroy) {
      try {
        destroy && destroy();
      } catch (e) {
        /* noop */
      }
    });
    destroyers = [];

    if (window.ScrollTrigger && window.ScrollTrigger.getAll) {
      window.ScrollTrigger.getAll().forEach(function (st) {
        st.kill();
      });
    }

    callbacks.forEach(function (fn) {
      try {
        var result = fn(createApi());
        if (typeof result === 'function') {
          destroyers.push(result);
        }
      } catch (e) {
        console.warn('[AboutEuhomy2] Section callback error:', e);
      }
    });

    if (window.ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  }

  function init() {
    if (initialized) return;
    initialized = true;

    whenLibsReady(function () {
      gsap.registerPlugin(ScrollTrigger);

      ScrollTrigger.config({
        ignoreMobileResize: true,
        limitCallbacks: true,
      });

      if (isMobileViewport()) {
        ScrollTrigger.normalizeScroll(true);
      }

      initLenis();
      document.documentElement.style.setProperty('--about-euhomy2-header-offset', getHeaderOffset() + 'px');
      runCallbacks();

      window.addEventListener(
        'resize',
        function () {
          document.documentElement.style.setProperty('--about-euhomy2-header-offset', getHeaderOffset() + 'px');
          if (window.ScrollTrigger) {
            ScrollTrigger.refresh();
          }
        },
        { passive: true }
      );

      document.addEventListener('shopify:section:load', function () {
        window.setTimeout(function () {
          if (window.AboutEuhomy2) window.AboutEuhomy2.refresh();
        }, 100);
      });

      document.addEventListener('shopify:section:unload', function () {
        window.setTimeout(function () {
          if (window.AboutEuhomy2) window.AboutEuhomy2.refresh();
        }, 100);
      });
    });
  }

  window.AboutEuhomy2 = {
    register: function (fn) {
      if (typeof fn !== 'function') return;
      callbacks.push(fn);
      if (initialized && window.gsap && window.ScrollTrigger) {
        try {
          var result = fn(createApi());
          if (typeof result === 'function') {
            destroyers.push(result);
          }
          if (window.ScrollTrigger) ScrollTrigger.refresh();
        } catch (e) {
          console.warn('[AboutEuhomy2] register error:', e);
        }
      }
    },

    refresh: function () {
      if (!initialized || !window.gsap) return;
      runCallbacks();
    },

    isMobile: isMobileViewport,

    getPinScrollOptions: getPinScrollOptions,

    getRem: getRem,

    remPx: remPx,

    destroy: function () {
      destroyers.forEach(function (destroy) {
        try {
          destroy && destroy();
        } catch (e) {
          /* noop */
        }
      });
      destroyers = [];
      callbacks = [];

      if (window.ScrollTrigger && window.ScrollTrigger.getAll) {
        window.ScrollTrigger.getAll().forEach(function (st) {
          st.kill();
        });
      }

      if (lenisInstance) {
        lenisInstance.destroy();
        lenisInstance = null;
        document.documentElement.classList.remove('lenis', 'lenis-smooth', 'lenis-stopped');
      }

      initialized = false;
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
